import { useEffect, useState } from "react";
import { useAppDispatch } from "../app/store";
import { AUTH_LOCALSTORAGE_NAME } from "../constants/constants";
import { userLoggedIn, userLoggedOut } from "../features/auth/authSlice";
import { AuthInitialState } from "../types";

export default function useAuthChecked() {
  const dispatch = useAppDispatch();
  const [authLoading, setAuthLoading] = useState(true);

  useEffect(() => {
    const localAuth = localStorage?.getItem(AUTH_LOCALSTORAGE_NAME);

    if (localAuth) {
      const auth = JSON.parse(localAuth) as AuthInitialState;

      if (auth?.access_token && auth?.user) {
        dispatch(userLoggedIn(auth));
      } else {
        dispatch(userLoggedOut());
      }
    }

    setAuthLoading(false);
  }, [dispatch, setAuthLoading]);

  return authLoading;
}
